import React from 'react';
import { useSelector } from 'react-redux';
import { MuiBox, Box, Backdrop, SvgIconButton, Logo, ContainerBox, Grid, SvgIcon } from '@kis-technologies/kis-ui';
import { actions as clientsActions, selectors as clientsSelectors, CreateClientPayload } from 'store/clients';
import { CreateCustomerForm } from './CreateCustomerForm';
import { useActions } from 'hooks/useActions';
import { useStyles } from '../../styled';

interface CreateCustomerOverlayProps {
  onClose: () => void;
}

export const CreateCustomerOverlay = ({ onClose }: CreateCustomerOverlayProps) => {
  const classes = useStyles()();

  const { createClient, resetAction } = useActions({
    createClient: clientsActions.createClient,
    resetAction: clientsActions.resetAction
  });

  const { pending } = useSelector(clientsSelectors.selectAction);

  const onCancelClick = () => {
    resetAction();
    onClose();
  };

  const handleCreateCustomer = (payload: CreateClientPayload) => {
    createClient(payload);
  };

  return (
    <Backdrop open>
      <Box bg="x-light-gray" height="100vh" width="100%" overflow="auto">
        <ContainerBox className={classes.createNewCustomerContainer}>
          <Box bg="white" sx={{ borderRadius: '32px 32px 0 0' }}>
            <Grid className={classes.createNewCustomerLogoBlock}>
              <MuiBox className={classes.createNewCustomerLogo}>
                <Logo />
              </MuiBox>
              <MuiBox className={classes.createNewCustomerCloseIcon}>
                <SvgIconButton data-testid="create-new-customer-close" onClick={onCancelClick} appearance="transparent">
                  <SvgIcon name="exit_circle" size={40} />
                </SvgIconButton>
              </MuiBox>
            </Grid>

            <CreateCustomerForm loading={pending} resetError={resetAction} onSubmit={handleCreateCustomer} />
          </Box>
        </ContainerBox>
      </Box>
    </Backdrop>
  );
};
